import React, { ChangeEvent, FC } from 'react'
import { PasswordInput as MantinePasswordInput } from '@mantine/core'
import useTranslation from 'next-translate/useTranslation'
import { useSignupFormContext } from '../formContext'

type Props = {}

const PasswordInput: FC<Props> = ({}) => {
  const form = useSignupFormContext()
  const { t } = useTranslation('user')
  const { onBlur, ...passwordProps } = form.getInputProps('password')

  const handlePasswordChange = (event: ChangeEvent<HTMLInputElement>) => {
    onBlur(event)
    form.isDirty('confirmPassword') && form.values.confirmPassword && form.validateField('confirmPassword')
  }
  return (
    <MantinePasswordInput
      size="md"
      placeholder={t('authentication.form.passwordInput.password')}
      autoComplete="new-password"
      onBlur={handlePasswordChange}
      {...passwordProps}
    />
  )
}

export default PasswordInput
